import React, { useState, useEffect } from "react";
import {
  Box,
  Drawer,
  Button,
  List,
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  AppBar,
  Typography,
  Grid,
  Toolbar,
  IconButton,
  CssBaseline,
  MenuItem,
  Collapse,
  Fade,
  Avatar,
  Tooltip,
  Stack,
} from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
  ChevronLeftOutlined,
  ChevronRightOutlined,
  ListAlt,
  LocalGroceryStore,
  Assessment,
  Add,
  Business,
  Hail,
  Hiking,
  PostAdd,
  AccountCircle,
  ReceiptOutlined,
  AddShoppingCart,
  LockOpen,
  PowerSettingsNew,
  ThreeDRotationSharp,
  Block,
  MenuOpen,
  CalendarMonthSharp,
} from "@mui/icons-material";
import HomeIcon from "@mui/icons-material/Home";
import MenuIcon from "@mui/icons-material/Menu";
import BusinessIcon from "@mui/icons-material/Business";
import DashboardIcon from "@mui/icons-material/Dashboard";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { styled, useTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";
import DropDownMenu from "./CustomTool/DropDownMenu";
import AcoountDropDownMenu from "./CustomTool/AcoountDropDownMenu";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import EventRepeatOutlinedIcon from "@mui/icons-material/EventRepeatOutlined";
import Logo from "../images/Logo.png";
import LogoSmall from "../images/R1.png";
import HailIcon from "@mui/icons-material/Hail";
import { hover } from "@testing-library/user-event/dist/hover";
import { connect } from "react-redux";
import {
  mapSetActiveMenu_DefAcYearCompany_SetLists_MenuVisibility_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { fetchTblMng } from "./API";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import CompanyList from "./CompanyList";
import HOCReduxData from "../HOC/HOCReduxData";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import CtBtn from "./CustomTool/CtBtn";
import { getAcYear_YYYY } from "../SystemUtility/SystemUtility";
import { withRouter } from "../HOC/withRouter";
import { defaultDateSetting } from "../SystemUtility/SystemUtility";
import useMediaQuery from "@mui/material/useMediaQuery";
import { CalendarIcon } from "@mui/x-date-pickers";

const drawerWidth = 240;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(1),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  }),
);

const AppBarConst = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

const Menu = (props) => {
  const isLargeScreen = useMediaQuery("(min-width:1100px)");
  const isLargeScreenForLogo = useMediaQuery("(min-width:1200px)");
  const isLargeScreenForHeanding = useMediaQuery("(min-width:500px)");
  const isLargeScreenForYear = useMediaQuery("(min-width:500px)");
  const LinkTo = ({
    ItemName,
    LinkSlug,
    activeMenu,
    setActiveMenu,
    activeStyle,
    open_inward,
    close_inward,
    stateValue,
    subMenuItems,
    navigate,
  }) => {
    return (
      <span>
        {LinkSlug && LinkSlug !== undefined ? (
          <Link
            to={LinkSlug ? LinkSlug : "#"}
            className="LinkTo"
            style={activeMenu === LinkSlug ? activeStyle : {}}
            onClick={() => setActiveMenu(LinkSlug)}
          >
            {ItemName}
          </Link>
        ) : (
          ""
        )}
      </span>
    );
  };

  const MenuListItemIcon = ({
    ItemName,
    LinkSlug,
    ItemIcon,
    activeMenu,
    handleDrawerClose,
    activeStyle,
    setActiveMenu,
    OnlyForAdmin,
    IsAdmin,
    subMenuItems,
    handleOnSubMenuClick,
  }) => {
    const [subMenuOpenState, setSubMenuOpenState] = useState(false);
    let result = (
      <div>
        <Link
          to={LinkSlug ? LinkSlug : "#"}
          className="menulink"
          onClick={() => {
            if (subMenuItems) {
              setSubMenuOpenState(!subMenuOpenState);
            } else {
              handleDrawerClose();
              setActiveMenu(LinkSlug);
            }
          }}
        >
          <ListItem
            key={ItemName}
            onClick={handleDrawerClose ? handleDrawerClose : null}
          >
            <ListItemIcon>
              {
                <ItemIcon
                  className="muicon"
                  style={activeMenu === LinkSlug ? activeStyle : {}}
                />
              }
            </ListItemIcon>
            <ListItemText>
              <span
                className="menulink"
                style={activeMenu === LinkSlug ? activeStyle : {}}
              >
                {ItemName}
              </span>
            </ListItemText>
          </ListItem>
        </Link>
      </div>
    );

    if (subMenuItems && OnlyForAdmin !== undefined) {
      if (IsAdmin !== undefined && IsAdmin() === true) {
        result = (
          <div>
            <div
              className="menulink"
              style={activeMenu === LinkSlug ? activeStyle : {}}
              onClick={() => {
                subMenuItems
                  ? setSubMenuOpenState(!subMenuOpenState)
                  : setActiveMenu(LinkSlug);
              }}
            >
              <ListItem
                button
                key={ItemName}
                onClick={handleOnSubMenuClick ? handleOnSubMenuClick : null}
              >
                <ListItemIcon>{<ItemIcon className="muicon" />}</ListItemIcon>
                <ListItemText primary={ItemName} />
                {subMenuItems ? (
                  subMenuOpenState ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )
                ) : null}
              </ListItem>
            </div>
            {subMenuItems ? (
              <Collapse in={subMenuOpenState} timeout="auto" unmountOnExit>
                {subMenuItems.map((curSubMenu) => {
                  if (
                    curSubMenu.privilege === "A" ||
                    curSubMenu.privilege === "R" ||
                    curSubMenu.privilege === "W" ||
                    curSubMenu.privilege === "M"
                  ) {
                    return (
                      <List
                        component="div"
                        disablePadding
                        style={{ backgroundColor: "#ECF6FA" }}
                      >
                        <Link
                          to={curSubMenu.LinkSlug ? curSubMenu.LinkSlug : "#"}
                          className="menulink"
                          style={
                            activeMenu === curSubMenu.LinkSlug
                              ? activeStyle
                              : {}
                          }
                        >
                          <ListItem button onClick={handleDrawerClose}>
                            <ListItemIcon>
                              {/* {curSubMenu.menuIcon} */}
                              {<curSubMenu.menuIcon className="muicon" />}
                            </ListItemIcon>
                            <ListItemText primary={curSubMenu.menuText} />
                          </ListItem>
                        </Link>
                      </List>
                    );
                  } else {
                    return "";
                  }
                })}
              </Collapse>
            ) : (
              ""
            )}
          </div>
        );
      } else {
        result = "";
      }
    }
    return result;
  };

  const DrawerMenuList = ({
    ItemIcon,
    ItemName,
    subMenuItems,
    setActiveMenu,
    LinkSlug,
    activeStyle,
    activeMenu,
    handleDrawerClose,
  }) => {
    const [openCurSubMenu, setOpenCurSubMenu] = useState(false);
    // console.log('activeMenu', activeMenu)
    // console.log('LinkSlug', LinkSlug)
    // console.log('subMenuItems', subMenuItems)
    subMenuItems.map((curSubMenu) => {
      if (activeMenu === curSubMenu.LinkSlug) {
        LinkSlug = curSubMenu.LinkSlug;
      }
    });
    let result = (
      <div>
        <List
          sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
          component="nav"
          aria-labelledby="nested-list-subheader"
        >
          <ListItemButton
            className="menulink"
            onClick={() => {
              if (subMenuItems) {
                setOpenCurSubMenu(!openCurSubMenu);
              } else {
                handleDrawerClose();
                setActiveMenu(LinkSlug);
              }
            }}
          >
            <ListItemIcon style={activeMenu === LinkSlug ? activeStyle : {}}>
              <ItemIcon />
            </ListItemIcon>
            <ListItemText>
              <lable
                className="menulink"
                style={activeMenu === LinkSlug ? activeStyle : {}}
              >
                {ItemName}
              </lable>
            </ListItemText>
            {subMenuItems ? (
              openCurSubMenu ? (
                <ExpandLess />
              ) : (
                <ExpandMore />
              )
            ) : (
              ""
            )}
          </ListItemButton>
          {subMenuItems ? (
            <Collapse in={openCurSubMenu} timeout="auto" unmountOnExit>
              {subMenuItems.map((curSubMenu) => {
                const menuVisible =
                  curSubMenu.setVisible !== undefined
                    ? curSubMenu.setVisible === false
                      ? "none"
                      : "block"
                    : "block";
                return (
                  <List component="div" disablePadding>
                    <Link
                      to={curSubMenu.LinkSlug ? curSubMenu.LinkSlug : "#"}
                      className="menulink"
                      onClick={handleDrawerClose}
                      style={{ display: menuVisible }}
                    >
                      <ListItemButton sx={{ pl: 4 }}>
                        <ListItemIcon
                          style={
                            activeMenu === curSubMenu.LinkSlug
                              ? activeStyle
                              : {}
                          }
                        >
                          <curSubMenu.menuIcon />
                        </ListItemIcon>
                        <ListItemText>
                          <lable
                            className="menulink"
                            style={
                              activeMenu === curSubMenu.LinkSlug
                                ? activeStyle
                                : {}
                            }
                          >
                            {curSubMenu.menuText}
                          </lable>
                        </ListItemText>
                      </ListItemButton>
                    </Link>
                  </List>
                );
              })}
            </Collapse>
          ) : (
            ""
          )}
        </List>
      </div>
    );
    return result;
  };

  const theme = useTheme();
  const bgColor = "#fff"; //'#d1e1e4' //'#e1f5fe' //'#eaf1ff'
  const activeStyle = { color: "#05699d", fontWeight: "600" };

  const [open, setOpen] = useState(false);
  const handleDrawerOpen = () => {
    setOpen(!open);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const [openSubMenu, setOpenSubMenu] = useState(false);
  const handleClickForSubMenu = () => {
    setOpenSubMenu(!openSubMenu);
  };

  const handleOnChangleProgressBarStatus = (status) => {
    if (status) {
      props.closeUpdateProcessing("info", "Loading Completed.");
    } else {
      props.notifyProcessing();
    }
  };

  const navigateTo = (link) => {
    props.navigate("/" + link);
  };

  const [ARD, setARD] = React.useState(null);

  const handleOnChangeARD = (ARD) => {
    setARD(ARD);
  };

  const openAcYearCompanyARD = () => {
    props.setAcYearCompanyInfo({
      defaultCompany: localStorage.getItem("CompanyName"),
      handleOnChangleProgressBarStatus,
      setAcYearCompanyList: props.setAcYearCompanyList,
      navigateTo,
      handleOnChangeARD,
      handleOnARDClose,
      displayARDSelection: true,
      setPrevAcYearCompany: props.setPrevAcYearCompany,
    });
  };

  const handleOnARDClose = () => {
    callBE_forTblMng();
    setARD(null);
  };

  const callBE_forTblMng = () => {
    // console.log(
    //   "localStorage.getItem('CompanyName')",
    //   localStorage.getItem("CompanyName")
    // );
    // console.log(
    //   "props.defAcYearCompany.PrevCompanyName",
    //   props.defAcYearCompany.PrevCompanyName
    // );
    // console.log(
    //   "localStorage.getItem('FullACY')",
    //   localStorage.getItem("FullACY")
    // );
    // console.log(
    //   "props.defAcYearCompany.PrevACY",
    //   props.defAcYearCompany.PrevACY
    // );

    const reqData = {
      Op: "CreateTable_acid_year",
      bint_acid: localStorage.getItem("acid"),
      bint_acyear: getAcYear_YYYY(localStorage.getItem("FullACY")),
    };
    props.notifyProcessing();
    fetchTblMng(reqData)
      .then((res) => {
        props.closeUpdateProcessing(res.data.msgType, res.data.message);
        if (res.data.BolNavigateToDetailMaster == true) {
          OpenARDForDetailMasterNavigate();
        } else if (
          localStorage.getItem("CompanyName") !==
            props.defAcYearCompany.PrevCompanyName ||
          localStorage.getItem("FullACY") !== props.defAcYearCompany.PrevACY
        ) {
          window.location.reload();
        }
      })
      .catch((error) => {
        props.toastErrorMsg(
          "Unknown error occurred dusing TblMng Be Call. " + error,
        );
      });
  };

  const OpenARDForDetailMasterNavigate = () => {
    setARD(null);
    const ARD = (
      <AlertResponsiveDialog
        labelDisagree="Ok"
        alertTitle={
          "Ledger Details Remain in Some Detail First Need to Set it."
        }
        alertMessage=""
        handleOnClickNo={() => {
          navigateTo("DetailMaster");
          setARD(null);
        }}
        defaultOpenDialog={true}
        onYesClickCloseIfExeSuccessfully={true}
      />
    );
    setARD(ARD);
  };

  useEffect(() => {
    // console.log("logInLinkText",localStorage.getItem("logInLinkText"));
    if (
      localStorage.getItem("logInLinkText") &&
      localStorage.getItem("logInLinkText") === "Log Out"
    ) {
      props.checkAndSetReduxData({
        lists: [], //props.lists
        handleOnChangleProgressBarStatus,
        setAcYearCompanyList: props.setAcYearCompanyList,
        navigateTo,
        handleOnChangeARD,
        handleOnARDClose,
        displayARDSelection: isLocalStorageSet(),
        setPrevAcYearCompany: props.setPrevAcYearCompany,
        setSubMenu_Master_Entry: props.setSubMenu_Master_Entry,
        setUserPrivileges: props.setUserPrivileges,
      });
    }
  }, [localStorage.getItem("logInLinkText")]);

  const isLocalStorageSet = () => {
    return !(
      localStorage.getItem("FullACY") &&
      localStorage.getItem("CompanyName") &&
      localStorage.getItem("acid") &&
      localStorage.getItem("FullACY").length > 0 &&
      localStorage.getItem("CompanyName").length > 0 &&
      localStorage.getItem("acid").length > 0
    );
  };

  let Displaydate = false;
  if (
    localStorage.getItem("dtpFromDate") ||
    (localStorage.getItem("dtpToDate") &&
      localStorage.getItem("dtpFromDate").length > 0) ||
    (localStorage.getItem("dtpToDate") != "").length > 0
  ) {
    Displaydate = true;
  } else {
    Displaydate = false;
  }
  const companyName = localStorage.getItem("CompanyName") || "";
  const ACY = localStorage.getItem("ACY") || "";
  return (
    <div style={{ display: "flex" }} key={props.defAcYearCompany.ACY}>
      <AppBarConst
        className="menufont"
        position="fixed"
        // open={true}
        sx={{
          backgroundColor: bgColor,
          zIndex: (theme) => theme.zIndex.drawer + 1, // important
        }}
      >
        <Toolbar style={{ backgroundColor: bgColor }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              color: "#515151",
              ":hover": {
                color: "#05699d",
              },
              mr: isLargeScreenForHeanding ? 2 : 0,
              // ...(open && { display: "none" }),
            }}
          >
            {open ? <MenuOpen /> : <MenuIcon />}
          </IconButton>
          <Typography
            variant="h6"
            noWrap
            component="div"
            style={{ width: "100%" }}
          >
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              marginTop={isLargeScreenForHeanding ? "0px" : "5px"}
            >
              <Grid item>
                <img
                  src={isLargeScreenForLogo ? Logo : LogoSmall}
                  alt="Logo"
                  style={{
                    width: isLargeScreenForLogo
                      ? "150px"
                      : isLargeScreenForHeanding
                        ? "50px"
                        : "40px",
                    height: "auto",
                    marginTop: "7px",
                  }}
                />
              </Grid>
              <Grid item style={{ marginRight: "5px" }}>
                <label
                  htmlFor="Title"
                  style={{
                    marginLeft: isLargeScreenForHeanding ? "10px" : "10px",
                    fontSize: isLargeScreenForLogo
                      ? "26px"
                      : isLargeScreenForHeanding
                        ? "20px"
                        : "20px",
                    color: "#515151",
                    fontWeight: 700,
                    fontFamily: "'Segoe UI', sans-serif",
                  }}
                >
                  {!isLargeScreenForHeanding && !isLargeScreenForLogo
                    ? (() => {
                        const titleText =
                          document.title.split(":")[1]?.trim() || "";
                        return titleText.length > 9
                          ? `${titleText.substring(0, 9)}...`
                          : titleText;
                      })()
                    : document.title.split(":")[1]?.trim()}
                </label>
              </Grid>
              <Grid item md marginLeft={"5px"}>
                {isLargeScreenForYear && (
                  <Box
                    display={{ xs: "block", md: "none" }}
                    style={{ textAlign: "left" }}
                  >
                    <List>
                      {localStorage.getItem("logInID") &&
                      localStorage.getItem("logInID") != "" ? (
                        <>
                          <Tooltip title={companyName}>
                            <CtBtn
                              bgColor="#ffffff"
                              fontColor="#05699D"
                              fontWeight={600}
                              label={
                                isLargeScreen
                                  ? "CMP : " + companyName
                                  : companyName.slice(0, 3)
                              }
                              onClick={openAcYearCompanyARD}
                            />{" "}
                          </Tooltip>
                          &nbsp;&nbsp;
                          <CtBtn
                            // bgColor='#198E33'
                            bgColor="#ffffff"
                            // bgColor='#C7FDD3'
                            fontColor="#198E33"
                            fontWeight={600}
                            label={
                              isLargeScreen
                                ? "FY : " + localStorage.getItem("FullACY")
                                : ACY.slice(2, 4) +
                                  "-" +
                                  (Number(ACY.slice(2, 4)) + 1)
                            }
                            onClick={openAcYearCompanyARD}
                          />
                        </>
                      ) : (
                        ""
                      )}
                    </List>
                  </Box>
                )}
                {!isLargeScreenForYear && (
                  <Grid container justifyContent="center" paddingBottom={1.2}>
                    <Grid item>
                      <Tooltip
                        title={
                          companyName
                          //  + " " + localStorage.getItem("FullACY")
                        }
                      >
                        <CtBtn
                          bgColor="#ffffff"
                          fontColor="#05699D"
                          fontWeight={600}
                          label={
                            companyName.slice(0, 3) +
                            " : " +
                            ACY.slice(2, 4) +
                            "-" +
                            (Number(ACY.slice(2, 4)) + 1)
                          }
                          onClick={openAcYearCompanyARD}
                        />
                      </Tooltip>
                    </Grid>
                  </Grid>
                )}
              </Grid>
              <Grid item md display={{ xs: "none", md: "block" }}>
                <Box
                  display={{ xs: "none", md: "block" }}
                  style={{ textAlign: "right" }}
                >
                  <List>
                    {localStorage.getItem("logInID") &&
                    localStorage.getItem("logInID") != "" ? (
                      <>
                        {/* <CtBtn
                          display={Displaydate}
                          bgColor="#ffffff"
                          fontColor="#05699D"
                          fontWeight={600}
                          label={"Default Date"}
                          onClick={defaultDateSetting}
                          width={150}
                        />
                        &nbsp;&nbsp; */}
                        <Tooltip title={companyName}>
                          <CtBtn
                            bgColor="#ffffff"
                            fontColor="#05699D"
                            fontWeight={600}
                            label={
                              isLargeScreen
                                ? "CMP : " + companyName
                                : companyName.slice(0, 3)
                            }
                            onClick={openAcYearCompanyARD}
                          />{" "}
                        </Tooltip>
                        &nbsp;&nbsp;
                        <CtBtn
                          // bgColor='#198E33'
                          bgColor="#ffffff"
                          // bgColor='#C7FDD3'
                          fontColor="#198E33"
                          fontWeight={600}
                          label={
                            isLargeScreen
                              ? "FY : " + localStorage.getItem("FullACY")
                              : ACY.slice(2, 4) +
                                "-" +
                                (Number(ACY.slice(2, 4)) + 1)
                          }
                          onClick={openAcYearCompanyARD}
                        />
                        <LinkTo
                          ItemName={"Dashboard"}
                          LinkSlug={"Dashboard"}
                          setActiveMenu={props.setActiveMenu}
                          activeStyle={activeStyle}
                          activeMenu={props.navInfo.activeMenu}
                        />
                        <DropDownMenu
                          MenuItems={props.navInfo.subMenuMaster}
                          MenuText="Master"
                          activeMenu={props.navInfo.activeMenu}
                          setActiveMenu={props.setActiveMenu}
                          handleLinkToOnClick={props.setActiveMenu}
                          activeStyle={activeStyle}
                        />
                        <DropDownMenu
                          MenuItems={props.navInfo.subMenuEntry}
                          MenuText="Entry"
                          activeMenu={props.navInfo.activeMenu}
                          setActiveMenu={props.setActiveMenu}
                          handleLinkToOnClick={props.setActiveMenu}
                          activeStyle={activeStyle}
                          // navigateTo={this.navigateTo}
                        />
                        <DropDownMenu
                          MenuItems={props.navInfo.subMenuReport}
                          MenuText="Report"
                          activeMenu={props.navInfo.activeMenu}
                          setActiveMenu={props.setActiveMenu}
                          handleLinkToOnClick={props.setActiveMenu}
                          activeStyle={activeStyle}
                          // navigateTo={this.navigateTo}
                        />
                        {/* Setting Menu*/}
                        {/* <DropDownMenu
                          MenuItems={props.navInfo.subMenuSetting}
                          MenuText="Setting"
                          activeMenu={props.navInfo.activeMenu}
                          setActiveMenu={props.setActiveMenu}
                          andleLinkToOnClick={props.setActiveMenu}
                          handleLinkToOnClick={props.setActiveMenu}
                          activeStyle={activeStyle}
                          // navigateTo={this.navigateTo}
                        /> */}
                      </>
                    ) : (
                      ""
                    )}
                    {/* <LinkTo
                      ItemName={localStorage.getItem("logInLinkText")}
                      LinkSlug={"/"}
                      activeMenu={props.navInfo.activeMenu}
                      setActiveMenu={props.setActiveMenu}
                      activeStyle={activeStyle}
                    /> */}
                  </List>
                </Box>
              </Grid>
              <Grid item sx={{ ml: "auto" }}>
                <AcoountDropDownMenu
                  avatarSrc=""
                  activeMenu={props.navInfo.activeMenu}
                  setActiveMenu={props.setActiveMenu}
                  // menuItems={[
                  //   { menuText: "Profile", LinkSlug: "profile" },
                  //   { menuText: "Settings", LinkSlug: "settings" },
                  //   { menuText: "Logout", LinkSlug: "logout" },
                  // ]}
                  menuItems={props.navInfo.subMenuSetting}
                />

                {/* <DropDownMenu
                  MenuItems={props.navInfo.subMenuSetting}
                  MenuText="Setting"
                  activeMenu={props.navInfo.activeMenu}
                  setActiveMenu={props.setActiveMenu}
                  andleLinkToOnClick={props.setActiveMenu}
                  handleLinkToOnClick={props.setActiveMenu}
                  activeStyle={activeStyle}
                  // navigateTo={this.navigateTo}
                /> */}
              </Grid>
            </Grid>
            {/* {!isLargeScreenForYear && (
              <Grid
                container
                justifyContent={"space-around"}
                // spacing={2}
                // paddingTop={0.5}
                paddingBottom={1.2}
              >
                <Grid item>
                  <Tooltip title={companyName}>
                    <CtBtn
                      bgColor="#ffffff"
                      fontColor="#05699D"
                      fontWeight={600}
                      label={
                        isLargeScreen
                          ? "CMP : " + companyName
                          : "CMP : " + companyName.slice(0, 3)
                      }
                      onClick={openAcYearCompanyARD}
                    />{" "}
                  </Tooltip>
                </Grid>
                <Grid item>
                  <CtBtn
                    // bgColor='#198E33'
                    bgColor="#ffffff"
                    // bgColor='#C7FDD3'
                    fontColor="#198E33"
                    fontWeight={600}
                    label={
                      isLargeScreen
                        ? "FY : " + localStorage.getItem("FullACY")
                        : "FY : " +
                          ACY.slice(2, 4) +
                          "-" +
                          (Number(ACY.slice(2, 4)) + 1)
                    }
                    onClick={openAcYearCompanyARD}
                  />
                </Grid>
              </Grid>
            )} */}
          </Typography>
        </Toolbar>
      </AppBarConst>
      <Drawer
        elevation={0}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            top: "64px", // 👈 AppBar height (change if needed)
            position: "fixed", // 👈 Required for top to work
            paddingTop: "10px",
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        {/* <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "ltr" ? (
              <ChevronLeftOutlined />
            ) : (
              <ChevronRightOutlined />
            )}
          </IconButton>
        </DrawerHeader> */}
        <Divider />
        {localStorage.getItem("logInID") &&
        localStorage.getItem("logInID") != "" ? (
          <>
            {/* <CtBtn
              display={Displaydate}
              bgColor="#ffffff"
              fontColor="#05699D"
              fontWeight={600}
              label={
                <>
                  <EventRepeatOutlinedIcon />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {"Default Date"}
                </>
              }
              onClick={defaultDateSetting}
              justifyContent={"flex-start"}
            />
            &nbsp; */}
            <Tooltip title={companyName}>
              <CtBtn
                bgColor="#ffffff"
                fontColor="#05699D"
                fontWeight={600}
                label={
                  <>
                    <BusinessIcon />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    {"CMP : " + companyName}
                  </>
                }
                onClick={openAcYearCompanyARD}
                justifyContent={"flex-start"}
              />
            </Tooltip>
            &nbsp;
            <CtBtn
              // bgColor='#198E33'
              bgColor="#ffffff"
              // bgColor='#C7FDD3'
              fontColor="#198E33"
              fontWeight={600}
              label={
                <>
                  <CurrencyRupeeIcon />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {"FY : " + localStorage.getItem("FullACY")}
                </>
              }
              onClick={openAcYearCompanyARD}
              justifyContent={"flex-start"}
            />
            <MenuListItemIcon
              ItemIcon={DashboardIcon}
              ItemName={"Dashboard"}
              LinkSlug={"Dashboard"}
              setActiveMenu={props.setActiveMenu}
              activeStyle={activeStyle}
              activeMenu={props.navInfo.activeMenu}
              handleDrawerClose={handleDrawerClose}
            />
            <DrawerMenuList
              ItemIcon={ListAlt}
              ItemName={"Master"}
              subMenuItems={props.navInfo.subMenuMaster}
              setActiveMenu={props.setActiveMenu}
              activeStyle={activeStyle}
              activeMenu={props.navInfo.activeMenu}
              handleDrawerClose={handleDrawerClose}
            />
            <DrawerMenuList
              ItemIcon={TextSnippetIcon}
              ItemName={"Entry"}
              subMenuItems={props.navInfo.subMenuEntry}
              setActiveMenu={props.setActiveMenu}
              activeStyle={activeStyle}
              activeMenu={props.navInfo.activeMenu}
              handleDrawerClose={handleDrawerClose}
            />
            <DrawerMenuList
              ItemIcon={TextSnippetIcon}
              ItemName={"Report"}
              subMenuItems={props.navInfo.subMenuReport}
              setActiveMenu={props.setActiveMenu}
              activeStyle={activeStyle}
              activeMenu={props.navInfo.activeMenu}
              handleDrawerClose={handleDrawerClose}
            />
            {/* Setting Menu*/}
            {/* <DrawerMenuList
              ItemIcon={ListAlt}
              ItemName={"Setting"}
              subMenuItems={props.navInfo.subMenuSetting}
              setActiveMenu={props.setActiveMenu}
              activeStyle={activeStyle}
              activeMenu={props.navInfo.activeMenu}
              handleDrawerClose={handleDrawerClose}
            /> */}
            <AcoountDropDownMenu
              avatarSrc=""
              activeMenu={props.navInfo.activeMenu}
              setActiveMenu={props.setActiveMenu}
              menuItems={props.navInfo.subMenuSetting}
              mobileView={true}
              handleDrawerClose={handleDrawerClose}
            />
          </>
        ) : (
          ""
        )}
        {/* <MenuListItemIcon
          ItemName={localStorage.getItem("logInLinkText")}
          LinkSlug={"/"}
          ItemIcon={
            localStorage.getItem("logInLinkText") == "Log In"
              ? LockOpen
              : PowerSettingsNew
          }
          activeMenu={props.navInfo.activeMenu}
          handleDrawerClose={handleDrawerClose}
          activeStyle={activeStyle}
          setActiveMenu={props.setActiveMenu}
        /> */}
      </Drawer>
      <Main open={open}>
        <DrawerHeader />
      </Main>
      <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
        {ARD}
      </Box>
    </div>
  );
};
export default connect(
  mapStatetoProps,
  mapSetActiveMenu_DefAcYearCompany_SetLists_MenuVisibility_ToProps,
)(HOCReduxData(HoCtToastContainer(withRouter(Menu))));
